
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Part } from '../types'

@Component({
    name: 'part-design-control',
})
export default class PartDesignControl extends Vue {
    @Prop({ type: Object }) part!: Part

    get lock(): boolean {
        return this.part.lock
    }
}
